export default {
    en: {
        termsOfUse: "Terms of Use",
        privacyPolicy: "Privacy Policy"
    },
    fr: {
        termsOfUse: "Conditions Générales d’Utilisations",
        privacyPolicy: "Politique de Confidentialité"
    },
}